var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-details"},[_c('v-card',{staticClass:"card"},[_c('h2',{staticClass:"order-summary__title"},[_vm._v(" "+_vm._s(_vm.$t("message.payments.paymentDetails"))+" ")]),_c('PaymentForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }